import { render, staticRenderFns } from "./MusicDifficulty.vue?vue&type=template&id=27f7285e&scoped=true&lang=pug&"
import script from "./MusicDifficulty.vue?vue&type=script&lang=js&"
export * from "./MusicDifficulty.vue?vue&type=script&lang=js&"
import style0 from "./MusicDifficulty.vue?vue&type=style&index=0&id=27f7285e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7285e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
